import React from "react";
import { Route, Switch } from "react-router-dom";
import _ from "lodash/fp";
import routes from "../../routes";
import * as styles from "./styles.module.css";
import logoBrand from "../../shared/images/LogoBrand.svg";

// Import your global styles here
import ErrorBoundary from "../error_boundary";

// wrap <Route> and use this everywhere instead, then when
// sub routes are added to any route it"ll work
const RouteWithSubRoutes = route => (
  <Route
    key={_.uniqueId()}
    exact={route.exact || false}
    path={route.path}
    render={props => (
      // Pass the sub-routes down to keep nesting
      <ErrorBoundary team={route.team || null}>
        <route.component {...props} routes={route.routes || null} />
      </ErrorBoundary>
    )}
  />
);

const App = () => (
  <React.Fragment>
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={styles.ebscoLogo}>
          <img
            className={styles.ebscoLogo__mobile}
            src={logoBrand}
            alt="EbscoHealth"
          />
        </div>
      </header>
      <main id="main-content" className={styles.mainContent}>
        <div data-auto="main-content-wrapper">
          <Switch>{routes.map(route => RouteWithSubRoutes(route))}</Switch>
        </div>
      </main>
    </div>
  </React.Fragment>
);

export default App;
